import React from 'react'
import { classNames } from '@/shared/lib/utils/classNames'
import cls from './Button.module.scss'
import { useTranslation } from 'react-i18next'

export const Button = ({ onClick, className }) => {
    const {t} = useTranslation()
    return (
        <button
            onClick={onClick}
            className={classNames(cls.Button, [className])}
        >
            <p>{t('navigation.contactus')}</p>
        </button>
    )
}
